import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import auth translations
import enAuth from '@/lib/i18n/resources/locales/en-US/auth.json';
import plAuth from '@/lib/i18n/resources/locales/pl-PL/auth.json';

// Import core translations
import enTranslation from '@core/lib/i18n/resources/locales/en-US/translation.json';
import plTranslation from '@core/lib/i18n/resources/locales/pl-PL/translation.json';


const resources = {
  'en-US': {
    translation: enTranslation,
    auth: enAuth,
  },
  'pl-PL': {
    translation: plTranslation,
    auth: plAuth,
  },
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en-US', 'pl-PL'],
    fallbackLng: 'en-US',
    defaultNS: 'auth',
    ns: ['translation', 'auth'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18next;